import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type AgentOfflineProps = {
  entry: UserAuditLogEntry<'AGENT_OFFLINE'>;
};

export const AgentOffline = ({ entry }: AgentOfflineProps): JSX.Element => {
  return (
    <UserActivityCard
      entry={entry}
      color={statusColors.info}
      icon="sign-out"
      title="Offline"
    />
  );
};
